import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormField } from '../formDefinition';
import { debounceTime, of, Subject, switchMap, takeUntil } from 'rxjs';
import { FormProgressService } from 'src/app/storage/form-progress.service';
import { IconService } from 'src/app/ui/icon.service';

@Component({
    selector: 'app-dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicFormComponent implements OnInit, OnDestroy {


  form: UntypedFormGroup;
  _formFields: FormField[] = [];
  groups: string[] = [];
  submitted = false;


  @Output() submit = new EventEmitter<any>();

  @Input() set formFields(value: FormField[]) {
    this.form = this.fb.group({})

    const groups: { [key: string]: UntypedFormGroup } = {};

    const parentControls: Set<string> = new Set();


    for (const field of value) {
      if (field.type !== 'heading') {
        if (field.group && !groups.hasOwnProperty(field.group)) {
          groups[field.group] = this.fb.group({});
          this.groups.push(field.group);
          this.form.addControl(field.group, groups[field.group]);
        }

        groups[field.group].addControl(field.name, this.fb.control(field.default ?? ''));

        if (field.required) {
          const control = groups[field.group].get(field.name);
          if (control) control.setValidators(Validators.required);
        }

        if (field.requireTrue) {
          const control = groups[field.group].get(field.name)
          if (control) control.addValidators(Validators.requiredTrue)
        }

        if (field.parentControl) {
          parentControls.add(field.parentControl.formKey);

        }
      }

    }

    for (const key of parentControls) {

      this.form.get(key)?.valueChanges.pipe(
        takeUntil(this.unsubscribe),
      )
        .subscribe((value) => {
          this._formFields.filter(f => f?.parentControl?.formKey === key)
            .forEach(f => {
              let compareValue = f?.parentControl?.visibleValue;
              if (typeof compareValue === 'string') {
                compareValue = [compareValue];
              }
              if (compareValue?.includes(value)) {
                this.getControl(f)?.enable();
              }
              if (!compareValue?.includes(value)) {
                this.getControl(f)?.disable();
              }

            })
        })
    }

    this._formFields = value;

    this.setUpSaveListener();

  }

  get formFields() {
    return this._formFields;
  }

  @Input() set formData(value: any) {

    this.form.patchValue(value);
  }

  @Input() formKey: string = "";

  @Input() disableSubmit: boolean = false;

  private unsubscribe = new Subject<void>()

  constructor(
    private fb: UntypedFormBuilder,
    private formProgressService: FormProgressService,
    private icons: IconService,
    private chRef: ChangeDetectorRef
  ) {
    this.form = fb.group({})
  }


  trackByFieldName(index: number, field: FormField) {
    return field.name
  }

  ngOnInit(): void {

   
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
  }

  setUpSaveListener() {
    this.form.valueChanges.pipe(
      debounceTime(500),
      switchMap(formValue => of(this.formProgressService.saveFormProgress(this.formKey, formValue))),
      takeUntil(this.unsubscribe)
    ).subscribe(() => console.log('Saved'))
  }

  onSubmit() {
    this.submitted = true;
    this.form.markAllAsTouched();
    if (this.form.valid) {

      const formCopy = JSON.parse(JSON.stringify(this.form.value))

      for (const field of this._formFields) {
        
          if (field.type === 'datetime' || field.type === "dob") {
            if (formCopy[field.group][field.name] === '') {
              delete formCopy[field.group][field.name];
            }
          }
      }

      this.submit.emit(formCopy);
    }
    else {
      this.chRef.detectChanges()
    }
  }

  getControl(field: FormField) {
    return this.form.get(field.group)?.get(field.name);
  }

  getControlByString(key: string) {

    return this.form.get(key);
  }

  isVisible(field: FormField) {
    if (field.parentControl) {
      const control = this.getControlByString(field.parentControl.formKey);
      if (control) {
        if (Array.isArray(field.parentControl.visibleValue)) {
          return field.parentControl.visibleValue.includes(control.value);
        } else {
          return control.value === field.parentControl.visibleValue;
        }
      }
    }
    return true;
  }

}


